"use client";
import { Button, Select, SelectItem } from "@heroui/react";
import Modal from "../component/Modals";
import React, { ChangeEvent, useState, useMemo } from "react";
import { showtype } from "../api/policy/route";
import { ApiRequest, useScreenSize } from "@/src/context/CustomHook";
import { errorToast } from "../component/Loading";
import { useGlobalContext } from "@/src/context/GlobalContext";
import { useRouter } from "next/navigation";

const showtypedata: Array<{ label: string; value: showtype }> = [
  { label: "Product Detail", value: "productdetail" },
  { label: "Receipt Email", value: "email" },
  { label: "Footer Link", value: "footer" },
  { label: "Checkout Page", value: "checkout" },
];

export const Showtypemodal = ({
  id,
  value,
}: {
  id: number;
  value: Set<string>;
}) => {
  const { setopenmodal } = useGlobalContext();
  const router = useRouter();
  const [values, setValues] = React.useState(value ?? new Set([""]));
  const [loading, setloading] = useState(false);
  const { isTablet, isMobile } = useScreenSize();

  const handleSelectionChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setValues(new Set(e.target.value.split(",")));
  };

  const handleUpdatePolicy = async () => {
    setloading(true);
    const value = Array.from(values)
      .filter((i) => i !== "")
      .join(",");
    const request = await ApiRequest("/api/policy", undefined, "PUT", "JSON", {
      id,
      showtype: value,
      ty: "showtype",
    });
    if (!request.success) {
      errorToast("Error Occured");
      return;
    }

    setopenmodal((prev) => ({ ...prev, showtype: false }));
    router.refresh();
  };

  const items = useMemo(() => showtypedata, []);

  const selectItems = useMemo(
    () =>
      items.map((data) => (
        <SelectItem key={data.value}>{data.label}</SelectItem>
      )),
    [items],
  );

  return (
    <Modal
      customwidth={isMobile ? "100vw" : isTablet ? "90vw" : ""}
      closestate="showtype"
      customZIndex={200}
    >
      <div className="w-full h-full bg-white rounded-lg p-3 flex flex-col gap-y-5">
        <h3 className="text-2xl font-bold">Set Policy For Display</h3>
        <Select
          fullWidth
          label="Show Type"
          selectionMode="multiple"
          placeholder="Select Type"
          selectedKeys={values}
          size="lg"
          onChange={handleSelectionChange}
        >
          {selectItems}
        </Select>
        <Button
          fullWidth
          isLoading={loading}
          size="lg"
          color="success"
          style={{ color: "white", fontWeight: "bold" }}
          variant="solid"
          onClick={() => handleUpdatePolicy()}
        >
          Confirm
        </Button>
        <Button
          fullWidth
          isLoading={loading}
          size="lg"
          variant="solid"
          style={
            !isMobile
              ? {
                  display: "none",
                }
              : {
                  backgroundColor: "lightcoral",
                  color: "white",
                  fontWeight: "bold",
                }
          }
          onClick={() => setopenmodal((prev) => ({ ...prev, showtype: false }))}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};
